import React, { useState, useEffect } from "react";
import Slider from "react-slick";

const MenuSlider = () => {
  const [active, setActive] = useState(0);
  const [current, setCurrent] = useState(1);

  const Dummy = [
    {
      id: 1,
      title: "Aksesoris Wanita",
    },
    {
      id: 2,
      title: "Rumah Tangga",
    },
    {
      id: 3,
      title: "Otomotif",
    },
    {
      id: 4,
      title: "Fashion Pria",
    },
    {
      id: 5,
      title: "Fashion Wanita",
    },
    {
      id: 6,
      title: "Jacket",
    },
    {
      id: 7,
      title: "Jacket Pria",
    },
    {
      id: 8,
      title: "Jacket Wanita",
    },
    {
      id: 9,
      title: "Blaze",
    },
    {
      id: 10,
      title: "sepatu",
    },
    {
      id: 11,
      title: "Kaos Kaki",
    },
    {
      id: 12,
      title: "Pakaian Bayi",
    },
    {
      id: 13,
      title: "Laptop",
    },
    {
      id: 14,
      title: "Handphone",
    },
    {
      id: 15,
      title: "Komputer",
    },
  ]

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: true,
    swipeToSlide: true,
    infinite: false,
    speed: 300,
    beforeChange: (current, next) => setActive(current),
    afterChange: current => setActive(current),
    prevArrow: active === 0 ? <HideArrow /> : false,
    // nextArrow: active > 4 ? <HideArrow /> : false,
  };

  useEffect(() => {
    setActive(0);
    setCurrent(1);
  }, [])

  return (
    <div className="menu-slider" style={{ maxHeight: "35px" }}>
      <Slider {...settings}>
        {
          Dummy.map((data) => {
            return (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a key={data.id} onClick={() => setCurrent(data.id)} className={current === data.id ? "active" : ""} >{data.title}</a>
            );
          })
        }
      </Slider>
    </div>
  );
};

const HideArrow = () => {
  return (
    <div
      style={{ display: "none" }}
    />
  );
}

export default MenuSlider;
